/**
 * External dependencies
 */
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { saveDashboard, resetDashboard } from "state/dashboard/actions";
import { isDirty } from "state/dashboard/selectors";

const AutoSaveLayout = (props) => {
  const [isSaving, setSaving] = useState(false);

  useEffect(() => {
    if (props.isDirty) {
      let interval = null;
      interval = setInterval(doSomething, 1000);
      return () => {
        return clearInterval(interval);
      };
    }
  }, [props.isDirty]);

  const doSomething = async () => {
    if (isSaving) {
      return;
    }
    setSaving(true);
    try {
      await props.saveDashboard();
    } catch (error) {
      await props.resetDashboard();
    }
    setSaving(false);
  };

  return null;
};

export default connect(
  (state) => ({
    isDirty: isDirty(state),
  }),
  {
    saveDashboard,
    resetDashboard,
  }
)(AutoSaveLayout);
